import React from "react";
import {
  Grid,
  IconButton,
  Dialog as MUIDialog,
  Typography,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";

import Form from "./Form";

export default function OnboardingDialog({ onboardDialog, setOnboardDialog }) {
  const handleClose = () => setOnboardDialog(false);

  return (
    <MUIDialog
      open={onboardDialog}
      onClose={handleClose}
      PaperProps={{
        sx: { minWidth: 900 }, // replaces makeStyles
      }}
    >
      <Grid container spacing={3} p={5}>
        <Grid item container alignItems="center">
          <Grid item xs={8}>
            <Typography variant="h4">Onboard Number</Typography>
          </Grid>

          <Grid item xs={4} display="flex" justifyContent="flex-end">
            <IconButton
              onClick={handleClose}
              disableRipple
              sx={{ p: "16px 24px" }}
            >
              <Cancel />
            </IconButton>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Form />
        </Grid>
      </Grid>
    </MUIDialog>
  );
}
